/** Removes null or undefined from its type. Its primary intention is for use with `list.filter`
 * Normal .filter prototype does not update the type to not include null or undefined */
export const isNonNullable = <T>(item: T): item is NonNullable<T> => item !== null && item !== undefined
